export default __webpack_public_path__ + "static/WhoWeAre-19e4b6c398b8f4eb6466c4826be7cc42.png";